import PropTypes from 'prop-types';

import Homecard from '@spotahome/marketplace-common/src/components/Homecard';
import { HomecardFormatter } from '@spotahome/ui-library/src/tenant/utils/images';
import { getDateAsUTC } from '@spotahome/ui-library/src/tenant/components/utils/dateUtils';

import './HomecardsList.scss';

const HomecardsList = ({ homecards }) => {
  const currentYear = getDateAsUTC(new Date()).getFullYear();

  return (
    !!homecards.length && (
      <div className="homecards-list">
        {homecards.map((homecard, position) => {
          const firstAvailableDate = getDateAsUTC(
            new Date(homecard.firstAvailableDate)
          );
          const photoUrls = HomecardFormatter.getPhotoUrls(homecard.photoIds);
          const firstAvailableYear = firstAvailableDate?.getFullYear();
          return (
            <div
              key={homecard.id}
              className="homecards-list__item"
              data-testid={`homecard-${homecard.id}`}
            >
              <Homecard
                isShowStatus
                data={{
                  ...homecard,
                  photoUrls
                }}
                position={position}
                tracking="ga-detail-properties-around-card"
                hasLazyLoad
                showAvailableFromYear={firstAvailableYear !== currentYear}
                withTransparentBackground
                pageType="seo_country_page"
              />
            </div>
          );
        })}
      </div>
    )
  );
};

HomecardsList.propTypes = {
  homecards: PropTypes.arrayOf(PropTypes.object).isRequired
};
export default HomecardsList;
